<cl-text-page-layout [fromError]="true">
  <div class="error-page">
    <router-outlet></router-outlet>
  </div>
</cl-text-page-layout>
